export default __webpack_public_path__ + "static/media/Eleni Kounalakis.41434bfe.jpg";